import { OrderState } from "@domain/states/order.state";

/**
 * Менеджер экземпляров OrderState
 * Хранит по одному OrderState на каждую машину
 */
class OrderFormStore {
  private states = new Map<number, OrderState>();
  
  /**
   * Получает OrderState для указанной машины
   * Создает новый экземпляр, если его еще нет
   */
  getOrder(machineId: number): OrderState {
    if (!this.states.has(machineId)) {
      console.log("[OrderFormStore] Creating new OrderState for machineId:", machineId);
      this.states.set(machineId, new OrderState(machineId));
    } else {
      console.log("[OrderFormStore] Reusing existing OrderState for machineId:", machineId);
    }
    return this.states.get(machineId)!;
  }
  
  /**
   * Удаляет OrderState для указанной машины
   */
  removeOrder(machineId: number): void {
    const state = this.states.get(machineId);
    if (state) {
      console.log("[OrderFormStore] Removing OrderState for machineId:", machineId);
      state.dispose();
      this.states.delete(machineId);
    }
  }
  
  /**
   * Удаляет все OrderState
   */
  removeAll(): void {
    console.log("[OrderFormStore] Removing all OrderStates");
    this.states.forEach((state, machineId) => {
      state.dispose();
    });
    this.states.clear();
  }
}

export const orderFormStore = new OrderFormStore();

